<template>
    <div :class="['short-info-block' ,'border-radius-10', 'd-flex', 'flex-column', 'align-items-stretch', 'justify-content-between', 'row-gap-2', {'isDisabled':isDisabled}]">
        <div class="upper-part d-flex justify-content-between align-items-start gap-4 w-100">
            <slot name="mainPart">
    
            </slot>
            <div class="d-flex align-items-center justify-content-end gap-4">
                <slot name="rightTopPart">

                </slot>
            </div>
        </div>
        <div class="lower-part w-100 d-flex align-items-center justify-content-between">
            <slot name="subPart">
                
            </slot>
            <slot name="rightBottomPart">

            </slot>
        </div>
    </div>
</template>
<script>
import primaryButtonComponent from './primaryButtonComponent.vue';
export default {
    components: {
        primaryButtonComponent,
    },
    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        }
    },
}
</script>
<style>
.short-info-block{
    padding: 1.2em;
    background-color: var(--secondary-background-color);
}
.short-info-block.isDisabled{
    background-color: var(--main-background-color);
}
</style>